import { useState } from 'react';
import { PassbookMarketingAdmin } from '@/features/marketing-shared/ui/passbook-marketing-admin';
import type { AdminClientPassbook } from '@/shared/types/client';
import { Label } from '@/shared/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select';

/**
 * Aba "Marketing" do hub do cliente (só master): saldo, consentimento e ajuste
 * de créditos de e-mail/SMS. Cliente com mais de um passbook escolhe qual.
 */
export function ClientMarketingTab({ passbooks, defaultId }: { passbooks: AdminClientPassbook[]; defaultId: string }) {
  const [selected, setSelected] = useState(defaultId);
  const current = passbooks.some((p) => p._id === selected) ? selected : defaultId;

  return (
    <div className="space-y-4">
      {passbooks.length > 1 ? (
        <div className="max-w-sm">
          <Label htmlFor="marketing-passbook" className="text-xs text-muted-foreground">
            Passbook
          </Label>
          <Select value={current} onValueChange={setSelected}>
            <SelectTrigger id="marketing-passbook" className="mt-1 w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {passbooks.map((p) => (
                <SelectItem key={p._id} value={p._id}>
                  {p.organizationName?.trim() || p.slug || p._id}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      ) : null}
      <PassbookMarketingAdmin key={current} idPassbook={current} />
    </div>
  );
}
